exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-nav {\n  width: 30%;\n  margin: auto;\n  z-index: 999;\n  margin-top: -15px;\n}\n.search-nav .custome-header-search {\n  overflow: initial;\n}\n.search-nav .custome-header-search .search-field {\n  width: 92%;\n  margin-top: 0;\n}\n.search-nav .custome-algolia-search-container .custome-algolia-search-result {\n  top: 2.5rem;\n}\n.header .navbar-menu .navbar-start {\n  max-height: 50px;\n  align-self: center;\n}", ""]);

// exports
